import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Box from '@mui/material/Box';

import { Dropdown, IconGraphy, Button, Alert } from '@leapeasy/ui-kit';
import {
  setDataAction,
  searchPropertyAction,
  setSuccessAction,
  setPropertyAction,
  getCoverageAmountAction,
} from 'redux/actions/getFormActions';

import { UsStates } from 'utils/constants';

const Form2 = (props) => {
  const { actions, token, formData, handleNext, handleBack } = props;

  const [state, setUSState] = useState(null);
  const [data, setFormData] = useState({
    property: null,
    address2: null,
    studentHousing: null,
  });
  const [value, setValue] = useState('');
  const [propertyData, setPropertyData] = useState([]);

  useEffect(() => {
    setFormData({
      property: formData.data.property,
      address2: formData.data.address2,
      studentHousing: formData.data.studentHousing,
    });
    setValue(formData.data.autoValue);
    setUSState(formData.data.state);
    let arrayData = [];
    if (formData.propertyArray && formData.propertyArray.length > 0) {
      formData.propertyArray.forEach((element) => {
        arrayData.push({
          text: element.Name,
          value: element.Id,
        });
      });
    }
    setPropertyData(arrayData);
  }, [formData]);

  const handleChange = (value, label) => {
    const building = formData.propertyArray.filter((item) => item.Id === value);

    setFormData({
      ...data,
      [label]: value,
      autoValue: building[0],
      studentHousing: building[0].Student_Housing__c,
      billingStreet: building[0].BillingStreet,
    });
  };

  const handleState = (event) => {
    setUSState(event.target.value);
    actions.setDataAction({
      ...formData.data,
      state: event.target.value,
      property: null,
      address2: null,
    });
    actions.setPropertyAction(null);
    actions.searchPropertyAction(event.target.value);
  };

  const handleNextButton = () => {
    actions.setDataAction({
      ...formData.data,
      property: data.property,
      studentHousing: data.studentHousing,
      address2: data.address2,
      autoValue: data.autoValue,
      billingStreet: data.billingStreet,
    });
    actions.setSuccessAction(null);
    actions.getCoverageAmountAction(data.property);
    handleNext();
  };

  return (
    <Fragment>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', flexGrow: 1 }}>
        <Box>
          <Dropdown
            value={state}
            size="medium"
            onChange={(e) => handleState(e)}
            options={UsStates.map((state) => ({
              text: state.abbreviation,
              value: state.abbreviation,
            }))}
            multiselect={false}
            placeholder="Select item"
            label="Apartment Location"
            showSearch={true}
            icon={
              <IconGraphy
                icon="MapTravel.Place"
                width={12}
                height={12}
                style={{ color: 'black' }}
              />
            }
            iconVisible
            style={{
              minWidth: '100%',
            }}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <Dropdown
            value={value}
            size="medium"
            onChange={(e) => {
              setValue(e.target.value);
              handleChange(e.target.value, 'property');
            }}
            options={propertyData}
            multiselect={false}
            showSearch={true}
            placeholder="Select item"
            label="Building Name"
            icon={
              <IconGraphy
                icon="HomePlaces.Apartment"
                width={12}
                height={12}
                style={{ color: 'black' }}
              />
            }
            iconVisible
            style={{
              minWidth: '100%',
            }}
            disabled={!propertyData.length}
          />

          {!propertyData.length && formData.success === 'success' && (
            <Alert description="Building doesn't exist!" />
          )}
        </Box>
        {/* {data.property && <Typography variant="body1" color="primary">Building is {data.studentHousing ? 'a' : 'not a'} Student Building</Typography>} */}
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="tertiary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          onClick={handleNextButton}
          disabled={!(state && data.property)}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        searchPropertyAction,
        setDataAction,
        setSuccessAction,
        setPropertyAction,
        getCoverageAmountAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form2);
